export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/photoshop_editing.39f6bf9.svg";